import React from "react";
import "./style.css";
import CoverImage from "../../../assets/FirstImage.png";

import TypedText from "../TypedText";
const CoverPage = () => {
  return (
    <div className={"coverContainer"}>
      <div className={"coverSmallContainer"}>
        <div>
          <p className={"CoverPageTitle"}>
            Vous êtes un Professionnel en Art Dentaire, {` `}
            {/* <span>EasyLab</span>{" "}
            c’est conçu pour Vous ! */}
            <TypedText style={{ color :"#0eaeba" }} strings={[`EasyLab`]} />
            <br />
            <TypedText strings={[`c’est conçu pour Vous !`]} />
          </p>

          <p className={"CoverPageDescription"}>
            Collaborer, Informer et s’informer de l’état instantanné de vos
            travaux, Gérer vos Projets Prothétiques pour une ergonomie
            organisationnelle Maximale. Accomplissez toutes vos tâches grace à
            votre Compte
            <br />
            <span className={"span1"}>#EasyLab </span>
          </p>
          <div style={{ textAlign: "center" }}>
            <button
              className={"Discover-Cover-button"}
              title="Gagnez du temps et de l'argent grâce à notre plateforme EasyLab.tn"
            >
              Vous êtes au bon endroit
            </button>
          </div>
        </div>
        <img alt={"CoverImage"} src={CoverImage} className={"CoverPageImage"} />
      </div>
    </div>
  );
};

export default CoverPage;
